import { isNil, isEqual, get, cloneDeep, clone, find } from 'lodash';
import { capitalize, removeEmpty } from 'utils';

/* eslint-disable object-shorthand */
export default {
  data() {
    return {
      stateData: null,
      formRef: null,
      originalData: {},
      formData: {},
      scroll: {
        container: '.nuttrema-layout-form-standard__center',
        offset: 10,
      },
    };
  },
  computed: {
    isDataChanged() {
      return !isNil(this.formData) && !isNil(this.originalData) && !isEqual(this.formData, this.originalData);
    },
    isSaving() {
      return get(this.stateData, 'saving', false);
    },
    isDeletion() {
      return get(this.stateData, 'deletion', false);
    },
    showDoneButton() {
      return !this.isDataChanged && get(this.stateData, 'saved', false);
    },
  },
  methods: {
    handleDelete() {
      this.$emit('delete');
    },
    clearValidate() {
      this.$nextTick(() => {
        this.$refs[this.formRef].clearValidate();
      });
    },
    cancelChanges() {
      this.$nextTick(() => {
        if (this.$refs[this.formRef]) this.$refs[this.formRef].clearValidate();
      });
      this.formData = cloneDeep(this.originalData);
      this.$emit('update:edit', false);
      this.$emit('cancel');
    },
    resetForm() {
      this.$refs[this.formRef].resetFields();
    },
    formatValidationMessage(message, field, cap = false) {
      const fieldTrans = field ? this.$t(field) : false;
      const messageTrans = fieldTrans ? this.$t(message, { field: fieldTrans }) : this.$t(message);
      if (cap) return capitalize(messageTrans);
      return messageTrans;
    },
    toJSON(data) {
      // console.log('toJSON', data);
      if (data) return JSON.parse(JSON.stringify(data));
      return new Error('Error parse data');
    },
    getFormData() {},
    setFormData() {},
    submitForm(validate = true, scroll = true) {
      const data = this.getFormData();
      if (validate) {
        this.$refs[this.formRef].validate((valid) => {
          if (valid) {
            this.$emit('submit', this.toJSON(data));
          } else if (scroll) {
            this.scrollToFirstError();
          }
          return valid;
        });
      } else {
        this.$emit('submit', this.toJSON(data));
      }
    },
    scrollToFirstError() {
      const centerContent = document.querySelector(this.scroll.container);

      const fields = this.$refs[this.formRef].fields;
      const element = find(fields, field => get(field, 'validateState') === 'error');

      if (centerContent && element) {
        // const topPos = get(element.$el, 'offsetTop');
        const topPos = get(element.$el, 'offsetParent.offsetTop');
        centerContent.scrollTop = topPos - this.scroll.offset;
      }
    },
    clone,
    cloneDeep,
    removeEmpty,
  },
  watch: {
    'stateData.saved': {
      handler: function () {
        this.originalData = cloneDeep(this.formData);
      },
      deep: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/mixins/form-standard-behavior.js